import { useEffect, useState, useRef } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { LoadingSpinner } from './components/ui/LoadingSpinner';
import AppRoutes from './routes/AppRoutes';
import { useAuthStore } from './store/authStore';

function App() {
  const { initializeAuth, isInitialized, isAuthenticated } = useAuthStore();
  const [isLoading, setIsLoading] = useState(true);
  const hasInitialized = useRef(false); // 중복 실행 방지

  // 앱 초기 로드 시 한 번만 서버에서 인증 상태 확인
  useEffect(() => {
    // 이미 초기화되었거나 실행 중이면 스킵
    if (isInitialized || hasInitialized.current) {
      setIsLoading(false);
      return;
    }

    // 실행 플래그 설정 (React Strict Mode 이중 실행 방지)
    hasInitialized.current = true;

    const checkAuth = async () => {
      try {
        await initializeAuth();
      } catch (error) {
        console.error('초기 인증 체크 실패:', error);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []); // 앱 마운트 시 한 번만 실행

  // 초기 인증 체크가 완료될 때까지 로딩 표시
  if (isLoading || !isInitialized) {
    return <LoadingSpinner message="인증 상태 확인 중..." fullScreen />;
  }

  return (
    <div className="min-h-screen">
      <BrowserRouter>
        <AppRoutes isAuthenticated={isAuthenticated} />
      </BrowserRouter>
    </div>
  );
}

export default App;
